import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import { Form, Input, Select, DatePicker, Button, Row, Col, Tooltip, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { constants, validationRules, utils } from '../../devUtils';
import { PersonalAddressFormProps, PersonalAddressFormmapStateToProps } from './IndusindMinKycDataHandler';
import { LAST_NAME_TOOLTIP_INFO } from './constants';


const { Option } = Select;

class PersonalAddressForm extends Component {
  constructor(props) {
    super(props);
    this.handlePersonalFormSubmit = this.handlePersonalFormSubmit.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
  }

  handlePersonalFormSubmit(evt) {
    evt.preventDefault();
    const { form: { validateFields }, handleNextStep } = this.props;
    validateFields((err, values) => {
      if (!err) {
        handleNextStep(0, values);
      }
    });
  }

  handleStateChange(selectedStateId) {
    const {
      onInitIndusindMinKycCities,
    } = this.props;
    onInitIndusindMinKycCities({ id: selectedStateId });
  }

  renderPersonalAddress() {
    const {
      form: {
        getFieldDecorator,
        getFieldValue,
      } = {},
      IndusindMinKycUserInfo: {
        data: {
          address_document_type: addressDocumentTypeList = [],
          salutation: salutationList = [],
          gender: genderList = [],
          marital_status: maritalStatusList = [],
          profession: professionList = [],
          states = [],
        } = {},
      } = {},
      formValues: {
        personalDetails: {
          emp_id = '',
          first_name = '',
          middle_name = '',
          last_name = '',
          salutation = '',
          gender = '',
          dob = '',
          marital_status = '',
          father_name = '',
          mother_name = '',
          mother_maiden_name = '',
          pan_card = '',
          mobile_number = '',
          address_document_number = '',
          address_document_expiry = '',
          address_document_issued_organization = '',
          address_document_place_of_issue = '',
          address_proof_document_type = '',
          profession = '',
        } = {},
      } = {},
    } = this.props;
    return (
      <Form
        className="steps-content"
        onSubmit={this.handlePersonalFormSubmit}
        layout="vertical"
      >
        <Row align="middle" type="flex" justify="start" gutter={20}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Employee ID">
                  {getFieldDecorator('emp_id', {
                    rules: [validationRules.mandatory],
                    initialValue: emp_id || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Employee ID"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="First Name">
                  {getFieldDecorator('first_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: first_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter First Name"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Middle Name">
                  {getFieldDecorator('middle_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: middle_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Middle Name"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item
                  label={(
                    <span>
                      Last Name
                      <Tooltip
                        title={LAST_NAME_TOOLTIP_INFO}
                      >
                        <Icon
                          type="info-circle"
                          className="custom-info-icon"
                        />
                      </Tooltip>
                    </span>
                  )}
                >
                  {getFieldDecorator('last_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: last_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Last Name"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Salutation">
                  {getFieldDecorator('salutation', {
                    rules: [validationRules.mandatory],
                    initialValue: salutation || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select a salutation"
                    >
                      {salutationList && salutationList.length && salutationList.map(({ id = '', value = '', name = '' }) => (
                        <Option key={id} value={value}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Gender">
                  {getFieldDecorator('gender', {
                    rules: [validationRules.mandatory],
                    initialValue: gender || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select Gender"
                    >
                      {genderList && genderList.length && genderList.map(({ id = '', value = '', name = '' }) => (
                        <Option key={id} value={value}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Date of Birth" >
                  {getFieldDecorator('dob', {
                    rules: [validationRules.dob_mandatory],
                    initialValue: dob ? utils.momentInstance(dob, constants.DATE_FORMAT_YYYYMMDD) : undefined,
                  })(
                    <DatePicker
                      className="custom-datepicker"
                      placeholder="Enter Date of Birth"
                      format={constants.DATE_FORMAT_YYYYMMDD}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabledDate={utils.disableDate}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Marital Status">
                  {getFieldDecorator('marital_status', {
                    rules: [validationRules.mandatory],
                    initialValue: marital_status || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select Marital Status"
                    >
                      {maritalStatusList && maritalStatusList.length && maritalStatusList.map(({ id = '', value = '', name = '' }) => (
                        <Option key={id} value={value}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Father’s Name">
                  {getFieldDecorator('father_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: father_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Father Name"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Mother’s Name">
                  {getFieldDecorator('mother_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: mother_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Mother Name"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Mother’s Maiden Name">
                  {getFieldDecorator('mother_maiden_name', {
                    rules: [validationRules.valid_input_field],
                    initialValue: mother_maiden_name || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Mother Maiden Name"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="PAN No">
                  {getFieldDecorator('pan_card', {
                    rules: [validationRules.valid_pan_number],
                    initialValue: pan_card || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter PAN Number"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Mobile Number">
                  {getFieldDecorator('mobile_number', {
                    rules: [validationRules.valid_mobile_number],
                    initialValue: mobile_number || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Mobile Number"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Address Document Type">
                  {getFieldDecorator('address_proof_document_type', {
                    rules: [validationRules.mandatory],
                    initialValue: address_proof_document_type || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select Address Document Type"
                    >
                      {addressDocumentTypeList && addressDocumentTypeList.length && addressDocumentTypeList.map(({ id = '', value = '', name = '' }) => (
                        <Option key={id} value={value}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              {getFieldValue('address_proof_document_type') === 'driving_license' ?
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Driving License No.">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Driving License Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Driving Expiry Date">
                      {getFieldDecorator('address_document_expiry', {
                        rules: [{ required: true, message: 'Please select date!' }],
                        initialValue: address_document_expiry ? utils.momentInstance(address_document_expiry, constants.DATE_FORMAT_YYYYMMDD) : undefined,
                      })(
                        <DatePicker
                          className="custom-datepicker"
                          placeholder="Select Expiry Date"
                          format={constants.DATE_FORMAT_YYYYMMDD}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabledDate={utils.disablePastDate}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Driving License Place of Issue">
                      {getFieldDecorator('address_document_place_of_issue', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_place_of_issue || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your State"
                          onChange={(selectedStateId) => this.handleStateChange(selectedStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Driving License Organisation">
                      {getFieldDecorator('address_document_issued_organization', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_issued_organization || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Select Driving License Issued Organisation"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment> : ''}
              {getFieldValue('address_proof_document_type') === 'nrega_or_mgnrega_job_card' ?
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Nrega License No.">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Nrega License Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Nrega Expiry Date">
                      {getFieldDecorator('address_document_expiry', {
                        rules: [{ required: true, message: 'Please select date' }],
                        initialValue: address_document_expiry ? utils.momentInstance(address_document_expiry, constants.DATE_FORMAT_YYYYMMDD) : undefined,
                      })(
                        <DatePicker
                          className="custom-datepicker"
                          placeholder="Enter Expiry Date"
                          format={constants.DATE_FORMAT_YYYYMMDD}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabledDate={utils.disablePastDate}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Nrega License Place of Issue">
                      {getFieldDecorator('address_document_place_of_issue', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_place_of_issue || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your State"
                          onChange={(selectedStateId) => this.handleStateChange(selectedStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Nrega License Organisation">
                      {getFieldDecorator('address_document_issued_organization', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_issued_organization || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Select Nrega License Issued Organisation"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment> : ''}
              {getFieldValue('address_proof_document_type') === 'ration_card' ?
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Ration Card Number">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Ration Card Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Ration Card Expiry Date">
                      {getFieldDecorator('address_document_expiry', {
                        rules: [{ required: true, message: 'Please select date !' }],
                        initialValue: address_document_expiry ? utils.momentInstance(address_document_expiry, constants.DATE_FORMAT_YYYYMMDD) : undefined,
                      })(
                        <DatePicker
                          className="custom-datepicker"
                          placeholder="Enter Expiry Date"
                          format={constants.DATE_FORMAT_YYYYMMDD}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabledDate={utils.disablePastDate}
                        />
                        // If you want to use a range of dates:
                        // <RangePicker className="custom-input" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Ration Card Place of Issue">
                      {getFieldDecorator('address_document_place_of_issue', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_place_of_issue || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your State"
                          onChange={(selectedStateId) => this.handleStateChange(selectedStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Ration Card Issued Organisation">
                      {getFieldDecorator('address_document_issued_organization', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_issued_organization || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Select Ration Card Issued Organisation"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment> : ''}
              {getFieldValue('address_proof_document_type') === 'passport' ?
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Passport Document Number">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Passport Document Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Passport Expiry Date">
                      {getFieldDecorator('address_document_expiry', {
                        rules: [{ required: true, message: 'Please select date!' }],
                        initialValue: address_document_expiry ? utils.momentInstance(address_document_expiry, constants.DATE_FORMAT_YYYYMMDD) : undefined,
                      })(
                        <DatePicker
                          className="custom-datepicker"
                          placeholder="Enter Expiry Date"
                          format={constants.DATE_FORMAT_YYYYMMDD}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabledDate={utils.disablePastDate}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Passport Place of Issue">
                      {getFieldDecorator('address_document_place_of_issue', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_place_of_issue || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your State"
                          onChange={(selectedStateId) => this.handleStateChange(selectedStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Passport Issued Organisation">
                      {getFieldDecorator('address_document_issued_organization', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_issued_organization || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Passport Issued Organisation"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment> : ''}
              {getFieldValue('address_proof_document_type') === 'voter_card' ?
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Voter Id Number">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Voter Id Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Voter Id Card Place Of Issue">
                      {getFieldDecorator('address_document_place_of_issue', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_place_of_issue || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your State"
                          onChange={(selectedStateId) => this.handleStateChange(selectedStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Voter ID Issued Organisation *">
                      {getFieldDecorator('address_document_issued_organization', {
                        rules: [validationRules.mandatory],
                        initialValue: address_document_issued_organization || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Voter ID Issued Organisation"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment> : ''}
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Profession">
                  {getFieldDecorator('profession', {
                    rules: [validationRules.mandatory],
                    initialValue: profession || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select a profession"
                    >
                      {professionList && professionList.length && professionList.map(({ id = '', value = '', name = '' }) => (
                        <Option key={id} value={value}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Nationality">
                  {getFieldDecorator('nationality', {
                    initialValue: 'INDIAN',
                  })(
                    <Input
                      className="custom-input"
                      disabled
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Country">
                  {getFieldDecorator('country', {
                    initialValue: 'INDIA',
                  })(
                    <Input
                      className="custom-input"
                      disabled
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-right">
          <Button
            className="margin-1 width-2"
            type="default"
          >
            <Link
              to={constants.LINK_PAY_BALANCE}
            >
            Cancel
            </Link>
          </Button>
          <Button
            className="green-btn margin-1 width-2"
            htmlType="submit"
          >
            Next
          </Button>
        </div>
      </Form>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderPersonalAddress()}
      </Fragment>
    );
  }
}

PersonalAddressForm.propTypes = PersonalAddressFormProps;

const PersonalAddressFormWrapper = Form.create({ name: 'normal_admin' })(PersonalAddressForm);
export default connect(PersonalAddressFormmapStateToProps, null)(PersonalAddressFormWrapper);
export { PersonalAddressForm, PersonalAddressFormWrapper };



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/PersonalAddressForm.js